import {ColDef} from "ag-grid-community";

export function columnDefs(): ColDef[] {

    return [
        {
            headerName: "Username",
            field: "userName",
            filter: "agTextColumnFilter",
            resizable: true
        }, {
            headerName: "Translation to confirm",
            field: "lang",
            filter: "agTextColumnFilter",
            resizable: true,
        },
        {
            headerName: "Last modified",
            field: "mTime",
            filter: "agTextColumnFilter",
            resizable: true,
            valueGetter: (params) => {
                let isoData = new Date(params.data.mTime)
                return isoData.toLocaleString("pl",{year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit", minute:"2-digit"})
                    .replace(/\./g,"-").replace(",","")
            }
        },
    ]
}
